import { Button } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ComponentCreateModal from '../modals/componentCreate';
import { isTeacher } from '../../../helpers/permissions';
import { UserType } from '../../../types/user';

const CreateNewComponent = () => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const onClick = () => {
        setIsModalOpen(true);
    };
    const onCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button
                data-cy="component-create-new"
                key={'workbench.lessons.create'}
                onClick={onClick}
                type="primary"
            >
                {t('workbench.lessons.newLesson')}
            </Button>
            {/* ----- Modal ----- */}
            <ComponentCreateModal isOpen={isModalOpen} onCancel={onCancel} />
        </>
    );
};

const getActions = (user: UserType): Array<React.ReactNode> => {
    // Authoring a lesson is a teacher/admin action (CREATE_COMPONENT command
    // is gated to [TEACHER, ADMIN] on the backend); don't render the button
    // for anyone who would only get a 403.
    if (isTeacher(user)) {
        return [<CreateNewComponent key={'create-new-component'} />];
    }
    return [];
};

export default getActions;
